import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component, ElementRef,
    HostListener,
    Input,
    OnInit, ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {merge, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {FuseNavigationService} from './navigation.service';
import {GeneralBroadcastService} from '../../../app/services/general-broadcast.service';
import {NavigationEnd, Router} from '@angular/router';
import {AuthService} from '../../../app/services/auth.service';


@Component({
    selector: 'fuse-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FuseNavigationComponent implements OnInit {
    @Input()
    layout = 'vertical';

    @Input()
    navigation: any;
    navigations = [];

    // Private
    private _unsubscribeAll: Subject<any>;
    selectedItemId: string;

    iconUrl = 'assets/sidebar-icons';
    currentUrl: string;
    currentYear = new Date().getFullYear();
    currentlySelectedItemId: string;
    tab: Window;
    @ViewChild('modalContent', {static: false}) modalContent: ElementRef;
    @ViewChild('itemContainer', {static: false}) itemContainer: ElementRef;

    /**
     *
     * @param event
     */
    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent): void {
        if (event.key === 'Escape') {
            this.closeSidebar();
        }
    }

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private generalBroadcastService: GeneralBroadcastService,
        private router: Router,
        private auth: AuthService
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.generalBroadcastService.sharedModuleId.subscribe(pData => {
            if (pData) {
                if (pData.includes('REPORT') || pData.includes('report')) {
                    this.selectedItemId = 'REPORT';
                } else {
                    this.selectedItemId = pData;
                }
            }
            // Load the navigation either from the input or from the service
            this.navigation = this.navigation || this._fuseNavigationService.getCurrentNavigation();

            // Subscribe to the current navigation changes
            this._fuseNavigationService.onNavigationChanged
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(() => {

                    // Load the navigation
                    this.navigation = this._fuseNavigationService.getCurrentNavigation();

                    // Mark for check
                    this._changeDetectorRef.markForCheck();
                });

            // Subscribe to navigation item
            merge(
                this._fuseNavigationService.onNavigationItemAdded,
                this._fuseNavigationService.onNavigationItemUpdated,
                this._fuseNavigationService.onNavigationItemRemoved
            ).pipe(takeUntil(this._unsubscribeAll))
                .subscribe(() => {

                    // Mark for check
                    this._changeDetectorRef.markForCheck();
                });
        });

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.currentUrl = event.url.split('?')[0];
            }
        });

    }

    itemOnClick(item, pEvent?: MouseEvent): void {
        const width = this.itemContainer.nativeElement.offsetWidth;
        const modal = document.getElementById('modal');
        modal.style.display = 'none';
        if (this.auth.isSuperAdmin) {
            this.closeSidebar();
            this.router.navigate([item.url]);
        } else {
            if (item.id == 'REPORT' || item.id == 'DASHBOARD') {
                this.closeSidebar();
                this.router.navigate([item.url]);
            } else if (item.id == 'DOWNLOAD') {
                this.closeSidebar();
                this.openDownloadTab();
            } else {
                if (this.currentlySelectedItemId == item.id) {
                    this.closeSidebar();
                    return;
                }
                this.navigations = item.children;
                this.currentlySelectedItemId = item.id;
                setTimeout(() => {
                    modal.style.display = 'block';
                    const createContainer = modal.querySelector('.sidebar-modal-content');
                    createContainer.scrollTop = 0;
                    const clickY = pEvent.clientY;
                    const viewportHeight = window.innerHeight - 100;
                    const modalHeight = this.modalContent.nativeElement.offsetHeight;
                    const shouldExpandUpwards = (clickY + modalHeight) > viewportHeight;
                    if (shouldExpandUpwards) {
                        if ((clickY - modalHeight) < 0){
                            modal.style.paddingTop = '0px';
                        } else {
                            modal.style.paddingTop = `${clickY - modalHeight}px`;
                        }
                    } else {
                        modal.style.paddingTop = `${clickY}px`;
                    }
                    modal.style.marginLeft = `${width + 5}px`;
                }, 0);
            }
        }
    }


    itemOnHover(item, itemIndex: number, pEvent?: MouseEvent): void {
        const width = this.itemContainer.nativeElement.offsetWidth;
        const height = this.itemContainer.nativeElement.offsetHeight;
        const modal = document.getElementById('modal');
        modal.style.display = 'none';
        if (this.auth.isSuperAdmin) {
            this.closeSidebar();
        } else {
            if (item.id == 'REPORT' || item.id == 'DASHBOARD') {
                this.closeSidebar();
            } else if (item.id == 'DOWNLOAD') {
                this.closeSidebar();
                this.openDownloadTab();
            } else {
                this.navigations = item.children;
                setTimeout(() => {
                    modal.style.display = 'block';
                    const createContainer = modal.querySelector('.sidebar-modal-content');
                    createContainer.scrollTop = 0;
                    const clickY = pEvent.clientY;
                    const viewportHeight = window.innerHeight - 100;
                    const modalHeight = this.modalContent.nativeElement.offsetHeight;
                    const shouldExpandUpwards = (clickY + modalHeight) > viewportHeight;
                    if (shouldExpandUpwards) {
                        if ((clickY - modalHeight) < 0){
                            modal.style.paddingTop = `${0}px`;
                        } else {
                            modal.style.paddingTop = `${((itemIndex + 1) * height) + 60 - modalHeight}px`;
                        }
                    } else {
                        modal.style.paddingTop = `${((itemIndex) * height) + 45}px`;
                    }
                    modal.style.marginLeft = `${width + 5}px`;
                }, 0);
            }
        }
    }

    containerLeave(): void {
        const modal = document.getElementById('modal');
        modal.style.marginLeft = 71 + 'px';
    }

    containerEnter(): void {
        const width = this.itemContainer.nativeElement.offsetWidth;
        const modal = document.getElementById('modal');
        if (modal) {
            modal.style.marginLeft = `${width + 5}px`;
        }
    }

    closeSidebar(): void {
        this.currentlySelectedItemId = null;
        const modal = document.getElementById('modal');
        modal.style.display = 'none';
    }

    openDownloadTab(): void {
        const url = window.location.origin + '/downloads/list';
        const tabName = 'Downloads';

        if (this.tab && !this.tab.closed) {
            this.tab.focus();
        } else {
            this.tab = window.open(url, tabName);
        }
    }
}
